(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["add-to-cart"] && !Shopify.designMode) return;
  try {
    /* Mirrors the offer widget's selected bundle price into the add-to-cart button.
     Reading the widget's own rendered figures keeps currency formatting and
     bundle maths identical to what the cart will receive, and each host only
     ever looks inside its own section so the two CTAs stay independent. */
  class RenesiaAtcPrice extends HTMLElement {
    connectedCallback() {
      this.now = this.querySelector('[data-rn-atc-now]');
      this.was = this.querySelector('[data-rn-atc-was]');
      this.wrap = this.querySelector('[data-rn-atc-price]');
      if (!this.now || !this.wrap) return;

      this.scope = this.closest('.shopify-section') || document;
      this.sync();

      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.scope, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    schedule() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.sync());
    }

    selected() {
      const widget = this.scope.querySelector('kaching-bundles-block');
      if (!widget) return null;
      // The subscription tabs share the bars class, so they are excluded here.
      return widget.querySelector(
        '.kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar--selected'
      );
    }

    sync() {
      const bar = this.selected();
      const text = (node) => (node ? node.textContent.trim() : '');
      let price = text(bar && bar.querySelector('.kaching-bundles__bar-price'));
      let compare = text(bar && bar.querySelector('.kaching-bundles__bar-full-price'));

      if (!price) {
        price = this.dataset.fallbackPrice || '';
        compare = this.dataset.fallbackCompare || '';
      }

      if (!price) {
        this.wrap.hidden = true;
        return;
      }

      if (this.now.textContent !== price) this.now.textContent = price;
      if (this.was) {
        const show = compare && compare !== price;
        if (show && this.was.textContent !== compare) this.was.textContent = compare;
        this.was.hidden = !show;
      }
      this.wrap.hidden = false;
    }
  }
  if (!customElements.get('renesia-atc-price')) {
    customElements.define('renesia-atc-price', RenesiaAtcPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["renesia-ship-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const FMT = { weekday: 'short', month: 'short', day: 'numeric' };

    function computeShipDate() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d;
    }

    function paint(root) {
      const target = root.querySelector('[data-rn-ship-date]');
      if (!target) return;
      const d = computeShipDate();
      try {
        target.textContent = d.toLocaleDateString(root.dataset.rnLocale || document.documentElement.lang || 'en-US', FMT);
      } catch (e) {
        target.textContent = d.toLocaleDateString('en-US', FMT);
      }
    }

    function geo(root) {
      if (root.dataset.geoFallback !== 'true') return;
      const cc = root.querySelector('[data-rn-ship-cc]');
      const flag = root.querySelector('[data-rn-ship-flag]');
      if (!cc || !flag) return;
      fetch('https://get.geojs.io/v1/ip/geo.json')
        .then((r) => (r.ok ? r.json() : null))
        .then((data) => {
          if (!data || !data.country_code) return;
          const code = String(data.country_code).toLowerCase();
          if (!/^[a-z]{2}$/.test(code)) return;
          cc.textContent = code.toUpperCase();
          flag.src = 'https://flagcdn.com/w40/' + code + '.png';
          flag.srcset = 'https://flagcdn.com/w80/' + code + '.png 2x';
        })
        .catch(() => {});
    }

    function init() {
      document.querySelectorAll('.rn-ship').forEach((root) => {
        paint(root);
        if (root.dataset.rnBound === 'true') return;
        root.dataset.rnBound = 'true';
        geo(root);
      });
    }

    // Refresh an open tab at local midnight, including daylight-saving changes.
    function scheduleRefresh() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      setTimeout(() => {
        init();
        scheduleRefresh();
      }, midnight.getTime() - now.getTime());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Theme editor re-renders blocks without a full page load.
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) init();
    });
    window.addEventListener('pageshow', init);
    scheduleRefresh();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["renesia-subscription-note"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NOTE = '[data-rn-subnote]';
    var DEAL_BARS = '.kaching-bundles__bars:not(.kaching-bundles__subscriptions)';
    var SUBS = '.kaching-bundles__subscriptions';
    var SELECTED = '.kaching-bundles__bar--selected';

    function visible(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }

    /* The widget renders more than one copy of its bars and hides all but the
       active layout, and the page carries a second buy box, so a note resolves
       against the nearest ancestor that actually contains a widget rather than
       against the whole document. */
    function scopeFor(note) {
      var el = note.parentElement;
      while (el && el !== document.body) {
        if (el.querySelector('kaching-bundle, .kaching-bundles')) return el;
        el = el.parentElement;
      }
      return document;
    }

    function readState(scope) {
      var subs = null;
      var candidates = scope.querySelectorAll(SUBS);
      for (var i = 0; i < candidates.length; i++) {
        if (visible(candidates[i])) { subs = candidates[i]; break; }
      }
      // No subscription switcher means there is nothing to promise.
      if (!subs) return null;

      var chosen = subs.querySelector(SELECTED);
      if (!chosen) return null;
      // The one-time tab is a selected bar too, so match on its label.
      if (/one[\s-]*time/i.test(chosen.textContent || '')) return null;

      var groups = scope.querySelectorAll(DEAL_BARS);
      for (var g = 0; g < groups.length; g++) {
        if (!visible(groups[g])) continue;
        var bar = groups[g].querySelector(SELECTED);
        if (!bar) continue;
        var match = (bar.textContent || '').match(/(\d+)\s*-?\s*month/i);
        if (!match) return null;
        return { months: parseInt(match[1], 10) };
      }
      return null;
    }

    function intervalLabel(note, months) {
      var key = 'interval' + months;
      var custom = note.dataset[key];
      if (custom) return custom;
      return months === 1 ? 'month' : months + ' months';
    }

    function prevVisible(el) {
      for (var n = el.previousElementSibling; n; n = n.previousElementSibling) {
        if (visible(n)) return n;
      }
      return null;
    }

    function nextVisible(el) {
      for (var n = el.nextElementSibling; n; n = n.nextElementSibling) {
        if (visible(n)) return n;
      }
      return null;
    }

    /* The note sits in a flex column whose gap differs between the two buy
       boxes, and the guarantee card below adds a margin of its own. Rather than
       hardcode a margin that is only right in one of them, measure the gap that
       is actually being rendered and correct by the difference. Arithmetic, so
       it lands in a single pass. */
    function applySpacing(note) {
      var above = parseFloat(note.dataset.spaceAbove);
      var below = parseFloat(note.dataset.spaceBelow);
      if (isNaN(above)) above = 8;
      if (isNaN(below)) below = 8;

      var rect = note.getBoundingClientRect();
      if (!rect.height) return;
      var style = getComputedStyle(note);

      var before = prevVisible(note);
      if (before) {
        var isAbove = Math.round(rect.top - before.getBoundingClientRect().bottom);
        var mt = Math.round((parseFloat(style.marginTop) || 0) + (above - isAbove));
        if (note.style.marginTop !== mt + 'px') note.style.marginTop = mt + 'px';
      }

      var after = nextVisible(note);
      if (after) {
        var isBelow = Math.round(after.getBoundingClientRect().top - rect.bottom);
        var mb = Math.round((parseFloat(style.marginBottom) || 0) + (below - isBelow));
        if (note.style.marginBottom !== mb + 'px') note.style.marginBottom = mb + 'px';
      }
    }

    function update(note) {
      var state = readState(scopeFor(note));
      if (!state) { note.hidden = true; return; }

      var line = note.querySelector('[data-rn-subnote-refill]');
      if (line) {
        var prefix = note.dataset.refillPrefix || 'Refills every';
        line.textContent = prefix + ' ' + intervalLabel(note, state.months);
      }
      note.hidden = false;
      applySpacing(note);
    }

    function sweep() {
      document.querySelectorAll(NOTE).forEach(update);
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sweep(); });
    }

    // The widget swaps classes on click and re-renders itself asynchronously,
    // so watch the tree rather than binding to bars that get replaced.
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    document.addEventListener('click', schedule, true);
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
